import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate } from "react-router-dom";
import User from "../../models/User";

export default function CreateAccountPage() {
    const navigate = useNavigate();
    const { backEnd_request, governorates, UserTypes } = BackMethods();

    const [roles, setRoles] = useState([]);
    const [user, setUser] = useState(new User());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    //  جلب الصلاحيات من السيرفر
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const res = await backEnd_request.get("/admin/Roles");
                setRoles(res.data);
                console.log(res.data);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        };
        fetchRoles();
    }, []);
    // 🔁 تحديث البيانات
    const handleChange = (field, value) => {
        setUser((prev) => new User({
            ...prev,
            [field]: field === "roleId" || field === "userType" ? Number(value) || 0 : value,
        }));
    };



    //  تحقق بسيط
    const validate = () => {
        if (!user.username?.trim()) return "الرجاء إدخال اسم المستخدم";
        if (!user.firstName?.trim()) return "الرجاء إدخال الاسم الأول";
        if (!user.phoneNumber?.trim()) return "الرجاء إدخال رقم الهاتف";
        if (!user.initialPassword?.trim()) return "الرجاء إدخال كلمة المرور الابتدائية";
        return "";
    };

    // إرسال الطلب
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSuccessMessage("");

        const error = validate();
        if (error) {
            setFormError(error);
            return;
        }
        console.log(user.userToCreateAccountAPI());
        setIsSubmitting(true);
        try {
            const res = await backEnd_request.post("/admin/UsersManagement", user.userToCreateAccountAPI());
            console.log("✅ تمت إضافة المستخدم:", res.data);
            setSuccessMessage("تم إنشاء الحساب بنجاح!");
            navigate("/admin/users-management", { state: { successMessage: "تم إنشاء الحساب بنجاح!" } });
            // setTimeout(() => navigate("/users"), 2000);
        } catch (err) {
            console.error(err.response.data.message);
            setFormError(err.response.data.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-dark min-vh-100 d-flex align-items-center py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h1
                        className="text-light fw-bold"
                        style={{ fontSize: "2.3rem", letterSpacing: "1px" }}
                    >
                        إنشاء حساب جديد
                    </h1>
                    <p className="text-light" style={{ fontSize: "1.1rem" }}>
                        يرجى إدخال جميع المعلومات المطلوبة لإنشاء حساب المستخدم
                    </p>
                </div>

                <div className="d-flex justify-content-center">
                    <div
                        className="card border-0 shadow-lg"
                        style={{
                            width: "100%",
                            maxWidth: "800px",
                            borderRadius: "20px",
                        }}
                    >
                        <div
                            className="card-header text-center py-4"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderTopLeftRadius: "20px",
                                borderTopRightRadius: "20px",
                            }}
                        >
                            <h3 className="text-dark m-0 fw-bold">معلومات الحساب</h3>
                        </div>

                        <div className="card-body bg-white p-5 rounded-bottom">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    {/* الاسم والمعلومات الشخصية */}
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="اسم المستخدم"
                                            value={user.username || ""}
                                            onChange={(e) => handleChange("username", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم الأول"
                                            value={user.firstName || ""}
                                            onChange={(e) => handleChange("firstName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="اسم الأب"
                                            value={user.fatherName || ""}
                                            onChange={(e) => handleChange("fatherName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الكنية"
                                            value={user.lastName || ""}
                                            onChange={(e) => handleChange("lastName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    {/* ☎️ بيانات الاتصال */}
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="رقم الهاتف"
                                            value={user.phoneNumber || ""}
                                            onChange={(e) => handleChange("phoneNumber", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={user.governorate || ""}
                                            onChange={(e) => handleChange("governorate", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value="">اختر المحافظة</option>
                                            {governorates.map((g) => (
                                                <option key={g} value={g}>
                                                    {g}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="المدينة"
                                            value={user.city || ""}
                                            onChange={(e) => handleChange("city", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="القطاع"
                                            value={user.sector || ""}
                                            onChange={(e) => handleChange("sector", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    {/*  القوائم المنسدلة */}
                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={user.userType || ""}
                                            onChange={(e) =>
                                                handleChange("userType", parseInt(e.target.value))
                                            }
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value="">نوع المستخدم</option>
                                            {UserTypes.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={user.roleId}
                                            onChange={(e) => handleChange("roleId", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value={0}>اختر الصلاحية</option>
                                            {roles.map((role) => (
                                                <option key={role.roleId} value={role.roleId}>
                                                    {role.displayName}
                                                </option>
                                            ))}
                                        </select>


                                    </div>

                                    {/*  كلمة المرور */}
                                    <div className="col-md-6">
                                        <input
                                            type="password"
                                            className="form-control p-3"
                                            placeholder="كلمة المرور الابتدائية"
                                            value={user.initialPassword || ""}
                                            onChange={(e) =>
                                                handleChange("initialPassword", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6 d-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="mustChangePassword"
                                                checked={user.mustChangePassword}
                                                onChange={(e) =>
                                                    handleChange("mustChangePassword", e.target.checked)
                                                }
                                            />
                                            <label
                                                className="form-check-label ms-2"
                                                htmlFor="mustChangePassword"
                                            >
                                                يجب تغيير كلمة المرور عند أول دخول
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* زر الإرسال */}
                                <div className="mt-4">
                                    <button
                                        type="submit"
                                        className={`btn w-100 py-3 fw-bold ${isSubmitting ? "btn-secondary" : "btn-dark text-light"
                                            }`}
                                        style={{ borderRadius: "12px", fontSize: "1.1rem" }}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "جارٍ الإرسال..." : "إنشاء الحساب"}
                                    </button>
                                </div>

                                {/* رسائل الخطأ / النجاح */}
                                {formError && (
                                    <div className="text-danger text-center mt-3 fw-bold">
                                        {formError}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="text-success text-center mt-3 fw-bold">
                                        {successMessage}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
